const init = () => {
  document.getElementById('copyBtn').addEventListener('click', function() {
    var textarea = document.getElementById('shareText');
    textarea.select();
    textarea.setSelectionRange(0, 99999); // Для мобильных устройств
    try {
      document.execCommand('copy');
      this.textContent = 'Скопировано!';
      setTimeout(() => {
        this.textContent = 'Скопировать текст';
      }, 1500);
    } catch (err) {
      alert('Не удалось скопировать текст');
    }
  });
};

const start = () => {
  document.addEventListener('DOMContentLoaded', init);
};

export default { init, start };
